import { render, staticRenderFns } from "./language_certificate.vue?vue&type=template&id=33e7235e"
import script from "./language_certificate.vue?vue&type=script&lang=js"
export * from "./language_certificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports